// footerScripts.js
const footerScripts = () => {
  const scripts = [
    '/assets/js/bootstrap.min.js',
    '/assets/js/scrollCue.min.js',
  ];

  scripts.forEach((src) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    // script.onload = () => console.log(`Loaded: ${src}`);
    script.onerror = () => console.error(`Failed to load: ${src}`);
    document.body.appendChild(script);
  });
};

export default footerScripts;
